module.exports = __webpack_public_path__ + "static/media/sportAvatar__csgo.5d7a8267.jpg";